<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Add Permission</h2>
            </div>
        </div>
        <a-card>
            <a-form :form="form"  @submit="handleSubmit">
                <a-row :gutter="16">
                    <a-col class="gutter-row" :span="12">
                        <a-form-item label="Name">
                            <a-input size="large"
                                v-decorator="['name', { rules: [{ required: true, message: 'Please enter name' }] }]"
                                placeholder="Enter name"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-form-item >
                    <a-button type="primary" size="large" class="btn btn-xs" html-type="submit">
                        Create Permission
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>
    </div>
</template>

<script>
import { alertPop } from "../../../script/helper";
    import { CREATE_PERMISSION } from "../../../script/api";
    import { postData } from "../../../script/api-service";

export default {
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "create_permission" });
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields(async (err, values) => {
        if (!err) {
            values.guard_name = "web";
            let res = await postData(CREATE_PERMISSION, values);

            if (res) {
                alertPop("success", "Permission Created Successfully");
                this.form.resetFields();
                this.$router.push({ path: '/manage-permission' });
            }
        }
      });
    },
  },
};
</script>